// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bridge"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 16.0004H3M3 16.0004H21M3 16.0004V3M3 16.0004V21.0004M21 16.0004H22M21 16.0004V3M21 16.0004V21.0004M7 16L7 8M12 16.0004V8M12 8C7.41421 8 4.58088 6.8317 3.5 6.28096M12 8C16.5864 8 19.4198 6.8314 20.5004 6.28074M17 16V8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BridgeIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bridge',
    ref,
    icon: element,
  },
));

BridgeIcon.displayName = 'BridgeIcon';

export default BridgeIcon;
